import styled from 'styled-components';
import {
    FiltersOutlined,
    CaretRightOutlined,
    BadgeSize,
    Progress,
} from '@landr/maestro';
import { AdvancedFiltersToggleHooks } from './types';

const StyledProgress = styled(Progress)`
    width: 24px;
    height: 24px;
`;

const useAdvancedFiltersToggle = ({
    genres,
    instruments,
    sfxs,
    bpmlowerbound,
    bpmupperbound,
    keyquality,
    keyrootnote,
    isSidebarOpen,
    isMobile,
    isLoading,
}: AdvancedFiltersToggleHooks) => {
    const bpmApplied = bpmlowerbound || bpmupperbound ? 1 : 0;
    const genresApplied = genres?.length ?? 0;
    const instrumentsApplied = instruments?.length ?? 0;
    const keyNoteApplied = keyrootnote ? 1 : 0;
    const keyQualityApplied = keyquality ? 1 : 0;
    const sfxsApplied = sfxs?.length ?? 0;

    const filtersAppliedTotal = [
        bpmApplied,
        genresApplied,
        instrumentsApplied,
        keyNoteApplied,
        keyQualityApplied,
        sfxsApplied,
    ].reduce((partialSum, a) => partialSum + a, 0);

    let icon: React.FC = isSidebarOpen ? CaretRightOutlined : FiltersOutlined;

    icon = isLoading ? StyledProgress : icon;

    const size: BadgeSize = isMobile ? 'sm' : 'md';

    return {
        total: filtersAppliedTotal,
        icon,
        size,
    };
};

export default useAdvancedFiltersToggle;
